<template>
  <div class="mx-auto w-100 w-md-80">

    <amio-header></amio-header>

    <div class="row mx-0 mt-4 mt-sm-6 mt-md-7">
      <div class="col-12 col-md-5 d-flex align-items-center px-4 px-md-0">
        <div>
          <h1>
            The most user-friendly<br/>
            <span class="font-weight-bold">
              Conversational AI Platform
            </span>
          </h1>
          <div class="mt-5 d-none d-md-block">
            <book-meeting class="book-demo-cta px-5">Book a demo
              <icon name="chevron-right" scale="1.3" class="book-demo-icon text-white ml-2 pb-1"></icon>
            </book-meeting>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-7 d-flex mt-0 mt-sm-6 mt-md-0 px-0 px-sm-5 pl-md-4 pr-md-0">
        <img src="~@/assets/img/hero_robot.svg" class="w-100 d-none d-sm-block" alt="robot">
        <img src="~@/assets/img/hero_robot_mobile.svg" class="w-100 d-block d-sm-none hero-small" alt="robot">
      </div>
    </div>
    <div class="d-flex d-md-none mt-2 mt-sm-7 justify-content-center">
      <book-meeting class="book-demo-cta px-6">Book a demo
        <icon name="chevron-right" scale="1.3" class="book-demo-icon text-white ml-2 pb-1"></icon>
      </book-meeting>
    </div>

    <customer-references class="border-top border-light mt-5 mt-md-7"/>

    <div class="row feature justify-content-center justify-content-lg-around align-items-center mt-7 mt-md-8 mx-auto"
         data-aos="fade-up" data-aos-duration="1000">
      <div class="col-10 col-lg-5">
        <h2><span class="font-weight-bold">Reduce the cost</span> of customer support</h2>
        <p class="mt-4 text-muted">
          Amio decreases call center costs by providing pre-trained natural language processing (NLP) models,
          access to all messaging channels, and ability to deflect customers to digital channels and self-service.</p>
      </div>
      <div class="col-10 col-lg-5 d-flex mt-4 mt-lg-0">
        <img src="~@/assets/img/hp/30_percent.png" class="mx-auto feature-image"/>
      </div>
    </div>

    <div class="row feature justify-content-center justify-content-lg-around align-items-center mt-5 mt-lg-8 mx-auto"
         data-aos="fade-up" data-aos-duration="1000">
      <div class="col-11 col-lg-5 order-1 order-lg-0 d-flex mt-4 mt-lg-0">
        <img src="~@/assets/img/hp/happy_customer.png" class="mx-auto feature-image"/>
      </div>
      <div class="col-10 col-lg-5 order-0 order-lg-1">
        <h2>Make your <span class="font-weight-bold">customers happier</span></h2>
        <p class="mt-4 text-muted">Be available 24/7 and answer immediately on the customers’ preferred channel.
          Moreover, let human-agents focus on complex cases with all the time they need.</p>
      </div>
    </div>

    <div class="row feature justify-content-center justify-content-lg-around align-items-center mt-5 mt-lg-8 mx-auto"
         data-aos="fade-up" data-aos-duration="1000">
      <div class="col-10 col-lg-5">
        <h2>Be independent and<br/><span class="font-weight-bold">own your virtual assistant</span></h2>
        <p class="mt-4 text-muted">
          Design, deploy, and analyze - all under your control.
          Empower customer support teams and let them become AI experts.
        </p>
      </div>
      <div class="col-10 col-lg-5 d-flex mt-4 mt-lg-0">
        <img src="~@/assets/img/hp/amio_hairdresser.png" class="mx-auto feature-image"/>
      </div>
    </div>

    <div class="row feature justify-content-center justify-content-lg-around align-items-center mt-5 mt-lg-8 mx-auto"
         data-aos="fade-up" data-aos-duration="1000">
      <div class="col-11 col-lg-5 order-1 order-lg-0 d-flex mt-4 mt-lg-0">
        <img src="~@/assets/img/hp/support_service.png" class="mx-auto feature-image"/>
      </div>
      <div class="col-10 col-lg-5 order-0 order-lg-1">
        <h2>
          Build on top of
          <br/>
          <span class="font-weight-bold">actionable insights</span>
        </h2>
        <p class="mt-4 text-muted">
          Your customers are evolving, so does your business. Improve the assistant based on precise insights,
          not assumptions.
        </p>
      </div>
    </div>

    <div class="row get-started justify-content-center mt-3 mt-md-7 py-8" data-aos="fade-up" data-aos-duration="1000">
      <div class="col-12 col-sm-7 col-lg-5 text-center">
        <h2 class="mb-3">Deploy virtual assistants in <span class="font-weight-bold">14 days!</span></h2>
        <div class="d-flex justify-content-center mt-5">
          <div class="bg-white">
            <book-meeting class="px-6">Request Free Trial</book-meeting>
          </div>
        </div>
      </div>
    </div>

    <amio-footer class="mt-5"></amio-footer>
  </div>
</template>

<script>

  import analyticsMixin from '@/mixins/analytics.mixin'
  import AmioFooter from '@/components/common/AmioFooter'
  import AmioHeader from '@/components/common/AmioHeader'
  import BookMeeting from '@/components/common/BookMeeting'
  import CustomerReferences from '@/components/common/CustomerReferences'
  import 'vue-awesome/icons/chevron-right'

  export default {
    mixins: [analyticsMixin],

    data() {
      return {
        boxClass: ''
      }
    },

    components: {
      AmioFooter,
      AmioHeader,
      BookMeeting,
      CustomerReferences
    },
    methods: {
      onClickContactUs: function () {
        this.trackContactUs()
      },

      onLogoHover(isHovered) {
        if (isHovered) this.boxClass = 'slide-in'
        else this.boxClass = 'slide-out'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .book-demo-icon {
    transition: transform .3s;
    transform: translate(1px, 0); //hack to make the button visually centered

  }
  .book-demo-cta:hover .book-demo-icon {
    transform: translate(6px, 0);
  }

  .bg-logo {
    background: none transparent;
  }

  .slide-in {
    animation: slide-in 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }

  .slide-out {
    animation: slide-out 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 0.5s;
  }

  .white-box {
    width: 100px;
    background-color: white;
    margin-left: -80px;
  }

  .feature-image {
    max-height: 300px;
    max-width: 100%;
    object-fit: contain;
  }

  .feature {
    width: 100%;
  }

  .get-started {
    background-image: url(~assets/img/get_started.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 130%;
  }

  .amio-logo {
    height: 36px;
  }

  /* prevents rows from creating horizontal scrollbars on mobile sized devices */
  .row {
    margin-left: 0;
    margin-right: 0;
  }

  @media (min-width: 350px) {
    .hero-small {
      min-height: 450px;
    }
  }

  /* sm breakpoint */
  @media (min-width: 540px) {

    .get-started {
      background-size: contain;
    }
  }

  /* md breakpoint */
  @media (min-width: 880px) {
    .amio-logo {
      height: 48px;
    }

    .get-started {
      background-size: contain;
    }

    .bg-logo {
      background-image: url(~assets/img/logo_transparent.svg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  @media (min-width: 1500px) {
    .feature {
      width: 80%;
    }
  }

  @keyframes slide-in {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(80px);
    }
  }

  @keyframes slide-out{
    0% {
      transform: translateX(80px);
    }

    100% {
      transform: translateX(0);
    }
  }
</style>
